<template>
    <div
        :id="`challengepage_${pageNumber}`"
        :class="`mb-2 bookpage challenge-page current-page challengepage_${pageNumber}`"
        :style="{
            width: '80%'
        }"
    >
        <p data-cy="challenge-content-container" class="chapter_content" v-html="pageText" ref="htmlContainer"></p>
    </div>
</template>
<script>
export default {
    name: 'ChallengePage',
    props: {
        texts: { type: Array, default: () => ({}) },
        pageNumber: { type: [Number, String], default: '' },
        active: { type: Boolean, default: false },
    },
    computed: {
        pageText() {
            const { texts } = this
            let result = ''

            texts.forEach(({ contenido }) => {
                result = `${result} ${contenido}${
                    contenido.endsWith('.') ? `<div class="my-2"></div>` : ''
                }`
            })
            return `
                <span>
                    ${result}
                </span>`
        },
    },
    mounted() {
        this.handleImageError();
    },
    methods: {
        handleImageError() {
            const images = this.$refs.htmlContainer.querySelectorAll('img');
            images.forEach((img) => {
                img.onerror = () => {
                    img.style.display = 'none'; // Oculta la imagen si ocurre un error de carga
                    img.parentElement.style.display = 'none';
                };
            });
        },
    },
    watch: {
        htmlContent() {
            this.$nextTick(() => {
                this.handleImageError();
            });
        }
    }
}
</script>
<style lang="scss">
    .challenge-page {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: justify;
    }

    .challenge-page .illustration {
       width: 100%;
       height: 100%;
        display: flex;
       justify-content: center;
       align-items: center;
       text-align: center;
    }

    .challenge-page .illustration img {
        width: 85%;
        height: 100%;
    }
    .chapter_content{
        @media screen and (max-width: 600px) {
            max-width: 100%;
            span, img{
                max-width: 100%;
                height: auto!important;
            }
        }
    }
</style>
